import {z} from 'zod';

/**
 * Schema for storage public URL response
 */
export const storagePublicUrlResponseSchema = z.object({
  downloadUrl: z.string(),
  expiresAt: z.string(),
  filename: z.string().optional(),
});

export type StoragePublicUrlResponse = z.infer<typeof storagePublicUrlResponseSchema>;
